import { axios } from "../utils/request";

export function apiGetJiwaiList(params) {
    let url = "/jiwai/page";

    let index = 0;
    for (let key in params) {
        if (index === 0) url += "?";
        url += "&" + key + "=" + params[key];
        index++;
    }

    return axios.get(url);
}

export function apiDeleteJiwai(jiwaiList) {
    let url = "/jiwai/post";

    let data = {
        Action: "delete",
        JiwaiList: jiwaiList
    };

    return axios.post(url, data);
}

export function apiSaveJiwai(jiwai) {
    let url = "/jiwai/post";

    let data = {
        Action: "save",
        Jiwai: jiwai
    };

    return axios.post(url, data);
}
